import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase'; // Ensure this path is correct for your Supabase client

export interface RentalVacancyRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  rental_vacancy_rate: number;
}

export function useRentalVacancyData(place: string | null, placeFips: string | null) {
  const [data, setData] = useState<RentalVacancyRecord[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!place || !placeFips) {
      setLoading(false); // Not loading if no params
      setData([]); // Clear data if no params
      setError(null); // Clear any previous errors
      return;
    }

    setLoading(true);
    setError(null);

    supabase
      .from('acs_bps_metrics_rental_vacancy') // Name of your view
      .select('*')
      .eq('Place', place)
      .eq('place_fips', placeFips)
      .order('year', { ascending: true })
      .then(({ data: supabaseData, error: supabaseError }) => {
        if (supabaseError) {
          console.error('Error fetching rental vacancy data:', supabaseError);
          setError(supabaseError.message);
          setData([]);
        } else {
          const sanitizedData = (supabaseData || []).map(record => ({
            ...record,
            rental_vacancy_rate: record.rental_vacancy_rate ?? 0,
          }));
          setData(sanitizedData);
          // Log the latest record for the selected city
          const latest = sanitizedData.slice(-1)[0];
          if (latest) {
            console.log(`Selected City: ${latest.Place}`);
            console.log(`  FIPS: ${latest.place_fips}`);
            console.log(`  Rental Vacancy Rate: ${latest.rental_vacancy_rate?.toFixed(2)}%`);
            console.log(`  Year: ${latest.year}`);
          }
        }
        setLoading(false);
      });
  }, [place, placeFips]);

  return { data, loading, error };
} 